module.exports = __webpack_public_path__ + "img/lei.c5cfcca2.png";